// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.table-responsive[data-v-344c4df6] {\n  width: calc(100% - 20px);\n}\n", ""]);
// Exports
module.exports = exports;
